import { SAVE_SESSION } from '../actions/session';

import Session from '../Session';

const defaultState = new Session();

export default (state = defaultState, action) => {
  switch (action.type) {
    case SAVE_SESSION:
      return action.session;

    default:
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/session.js